/**
 * These are typescript helper functions for when we have typed keys in an object as this
 * functionality isn't supported by the array types natively.
 */
export const keys = <T extends string>(obj = {}): T[] => Object.keys(obj) as T[];
export const entries = <T extends string, U>(obj = {}): [T, U][] =>
  Object.entries<U>(obj) as [T, U][];

export const chunk = <T>(array: T[], chunkSize: number): T[][] => {
  const chunkedArray = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunkedArray.push(array.slice(i, i + chunkSize));
  }
  return chunkedArray;
};
